module.exports = __webpack_public_path__ + "static/img/13.e4e0a32.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/7/sp/13.png
// module id = ASAe
// module chunks = 0